(function () {
  angular.module('MktzapApp.Factories')
    .factory('InsuranceErrorInfoService', InsuranceErrorInfoService);

    InsuranceErrorInfoService.$inject = ['$resource'];

  function InsuranceErrorInfoService ($resource) {
    return $resource('', {}, {
      getInsuranceErrorInfo: { url: frontUrl + '/insurance-error-info/getInsuranceErrorInfo', method: 'GET', isArray: false },
      getInsuranceErrorInfoById: { url: frontUrl + '/insurance-error-info/getInsuranceErrorInfoById', method: 'GET', isArray: false },
      registerInsuranceErrorInfo: { url: frontUrl + '/insurance-error-info/save', method: 'POST', params: {}, isArray: false },
      deleteInsuranceErrorInfo: { url: frontUrl + '/insurance-error-info/deleteInsuranceErrorInfo', method: 'POST', params: {}, isArray: false },
      editInsuranceErrorInfo: { url: frontUrl + '/insurance-error-info/editInsuranceErrorInfo', method: 'POST', params: {}, isArray: false }
    });
  }
})();